const RESERVATION_LIST_TYPE = {
    DEPARTURE_DATE: 0,
    PICKUP_DATE: 1,
    SALES_DATE: 2,
}

export { RESERVATION_LIST_TYPE }
export default RESERVATION_LIST_TYPE



// WEBPACK FOOTER //
// ./src/enums/reservationListType.js